export const Constant = {
    WS_CHAT_PREFIX: 'WS_CHAT',
    WS_PREFIX: 'WS',
    WS_NOTIFICATION_PREFIX: 'WS_NOTIFICATION',
    ACCOUNT: '_paymentO0ZAAAAAl_',
    LOCALE: '_paymentO0ZAAAAAlORDDLFK_',
    USER_PROFILE: '_paymentO0ZAAAAAlell_',
    API_BASE: getApiBaseUrl(),
    WS_API_BASE: "ws://localhost:9000",
    RECAPTCHA_SITE_KEY: "6LdPiO0ZAAAAAIrvraJPYSeKYbxL50jjCq_w6p2b",
    RECAPTCHA_NOT_SET: "RECAPTCHA_NOT_SET",
    fallbackLocale: "fr-FR",
    supportedLocales: {
        'en-US': "English",
        'fr-FR': "Français",
    }
}

function getApiBaseUrl() {
    if (process.env.NODE_ENV === 'development') {
        return process.env.REACT_APP_API_ENDPOINT;
    }
    return 'API_BASE_URL';
}
